import QRCodes from "../../auth/FirstLogin/AppStoreQRCodes";
import StepWrapper from "../StepWrapper";

const FinishStep = () => {
  return (
    <StepWrapper
      title="Final Thing - Download the App!"
      description="The mobile app is the most convenient way to start recording your appointments. Scan the QR code below for your respective device, or tap if you are already using a mobile device."
      withBackground={false}
    >
      <div className="w-full flex flex-row items-center justify-center">
        <QRCodes onboardingMode={true} />
      </div>
    </StepWrapper>
  );
};

export default FinishStep;
